/* AIVIQ search page (sections/aiviq-search.liquid). Written by hand.
   The tabs show one group of results without a reload; »Brug chatten« opens the shop's chat. */
(function () {
  'use strict';
  var page = document.querySelector('[data-asq-page]');
  if (!page) return;
  var tabs = page.querySelector('[data-asq-tabs]');
  if (tabs) {
    var groups = Array.prototype.slice.call(page.querySelectorAll('[data-asq-group]'));
    tabs.addEventListener('click', function (e) {
      var b = e.target.closest('[data-asq-tab]');
      if (!b) return;
      var t = b.getAttribute('data-asq-tab');
      Array.prototype.forEach.call(tabs.querySelectorAll('[data-asq-tab]'), function (x) {
        var on = x === b;
        x.classList.toggle('is-on', on);
        x.setAttribute('aria-pressed', String(on));
      });
      groups.forEach(function (g) { g.hidden = t !== 'alle' && g.getAttribute('data-asq-group') !== t; });
    });
  }
  page.addEventListener('click', function (e) {
    if (!e.target.closest('[data-asq-chat]')) return;
    var box = document.getElementById('userlink-chat-bubble-container');
    var el = box && (box.querySelector('button, [role="button"]') || box);
    if (el) el.click(); else window.location.href = 'mailto:info@aiviq.dk';
  });
})();
